
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableRT(): TemplateResult<fitmentTableRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function repeatField2(isCollapsible, field, fieldIndex) {
        return _createElement('div', {
            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
            'key': field
        }, _createElement('div', mergeProps({ 'className': 'fitment-cell__value' }, { dangerouslySetInnerHTML: { __html: typeof field === 'undefined' ? '' : field } })));
    }
    function repeatAlwaysVisibleValues3(isCollapsible, alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '2141'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function scopeFieldValue3(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement.apply(this, [
                        'div',
                        {
                            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                            'key': value
                        },
                        value ? _map(Array.isArray(value) ? value : value.split('\n'), repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value)) : null
                    ]);
                }
                function repeatFitment4(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue3.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment4.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues4(isCollapsible, initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '2141'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function scopeFieldValue3(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement.apply(this, [
                        'div',
                        {
                            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                            'key': value
                        },
                        value ? _map(Array.isArray(value) ? value : value.split('\n'), repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value)) : null
                    ]);
                }
                function repeatFitment4(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue3.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment4.bind(this))
                ]);
            }, { count: undefined })];
    }
    function scopeIsCollapsible5() {
        var isCollapsible = this.initiallyHiddenValues?.length > 0;
        return _createElement('div', { 'className': 'cm_fitment-table fitment-table-container' + (this.isCollapsed ? ' cm_fitment-table-collapsed' : '') }, _createElement('div', { 'className': 'cm_fitment-table-header cm_mobile-hide' }, _createElement('span', { 'className': 'cm_fitment-table-header-title' }, 'VEHICLE FITMENT')), this.noFitmentData ? _createElement('div', {
            'className': 'fitment-table-title no-fitment-data',
            'key': '339'
        }, '\n    ', window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`), _createElement('br', {}), window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`), '\n  ') : null, this.universalFit ? _createElement('div', {
            'className': 'fitment-table-title universal-fit',
            'key': '607'
        }, '\n    ', window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || _translate(`fitment_universal_title`), _createElement('br', {}), window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || _translate(`fitment_universal_text`), '\n  ') : null, this.manyFitments ? _createElement('div', {
            'className': 'fitment-table-title many-fitments',
            'key': '991'
        }, '\n    ', _translate(`fitment_table_many_fitments`), '\n  ') : null, this.template === 'horizontal' ? _createElement('div', {
            'className': 'cm_fitment-table__horizontal cmTemplate_horizontal',
            'key': '1126'
        }, [_createElement('div', {
                'className': 'fitment-table-body fitment-table-header',
                'key': '12440'
            }, _createElement.apply(this, [
                'div',
                { 'className': 'fitment-row' },
                _map(this.fields, repeatField2.bind(this, isCollapsible))
            ]))], _createElement.apply(this, [
            'div',
            { 'className': 'fitment-table-body fitment-table-fitment' + (isCollapsible ? ' cm_fitment-table-body-content-collapsed' : '') + ' cmRepeater_alwaysVisibleValues' },
            _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues3.bind(this, isCollapsible))
        ]), _createElement.apply(this, [
            'div',
            { 'className': 'fitment-table-body fitment-table-fitment cm_collapsible-elem cmRepeater_initiallyHiddenValues' },
            _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues4.bind(this, isCollapsible))
        ])) : null, this.initiallyHiddenValues?.length ? _createElement('div', {
            'className': 'cm_fitment-table_collapse-button-container',
            'key': '5370'
        }, _createElement('button', {
            'className': 'cm_fitment-table_collapse-button btn btn--primary',
            'onClick': this.toggleCollapsed
        }, this.isCollapsed ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.isCollapsed ? [_translate(`show_less`)] : null)) : null);
    }
    return scopeIsCollapsible5.apply(this, []);
}
        export const componentNames = []